/***
 * @file:
 * @author: linkun.he
 * @Date: 2020-08-03 09:15:11
 */
import { Component } from '@angular/core';

import { SettingsService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';

@Component({
  selector: 'dt-header-i18n',
  templateUrl: './i18n.component.html',
  styleUrls: ['./i18n.component.scss'],
  host: {
    '[class.cursor]': 'true',
  },
})
export class HeaderI18nComponent {
  langs: any[];

  constructor(public settings: SettingsService, private i18nSrv: I18NService) {
    this.langs = this.i18nSrv.getLangs();
  }

  change(lang: string) {
    // this.i18n.use(lang);
    this.i18nSrv.setTranslations(lang);
    this.settings.setLayout('lang', lang);
  }
}
